// @flow
import isDate from 'validator/lib/isDate';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';

export function isValidEmail(email) {
  return isEmail(email);
}

export function isCompanyEmail(email) {
  return /^[^@]+@+(?!.*outlook|.*msn|.*icloud|.*fastmail|.*protonmail|.*hotmail|.*gmail|.*yahoo|.*rediff).*\.[^@]+$/.test(
    email.toLowerCase(),
  );
}

export function isValidMobileNumber(number) {
  return isMobilePhone(number, ['en-IN']);
}

export function isValidDate(date) {
  return isDate(date);
}
